import ListItem from "./ListItem.vue";
import { sendRemoveTeethRequest } from "@/api/toothApi";
import { setHighlightedToothColor } from "../../App";
import { highlightOutlines } from "@/components/dicom/slice.js";
import {
  focusTooth,
  unfocusTooth,
} from "@/components/tooth/focus/ToothFocusMode";
import {
  ToothNumberMode,
  initToothNumberControls,
} from "../tooth/number/ToothNumberMode";
import { showToothNumberDialog } from "../tooth/number/ToothNumberDialog.vue";
import { updateDisplayNumberAndName } from "@/components/tooth/teethNaming.js";

function fillTeethList() {
  // console.log("fillTeethList", vueApp.allItems);

  const teethList = document.getElementById("teethList");
  teethList.innerHTML = "";

  vueApp.allItems.forEach((item) => {
    // item.displayName = item.isTooth
    //   ? item.filename.replace(".stl", "")
    //   : item.name.toLowerCase();
    // item.displayNumber = item.number;
    if (item.isTooth) updateDisplayNumberAndName(item);
    else {
      item.displayName = item.name.toLowerCase();
      if (item.isBone && item.isMaxilla) {
        // console.log("fillTeethList", vueApp.allItems);
        item.displayName = "max. comp.";
      }
    }

    item.isHovered = false;
    item.isDeleted = false;
    item.isFocused = false;
    item.isHidden = false;
    item.isClicked = false;

    const itemInstance = new Vue({
      ...ListItem,
      propsData: {
        item: item,
      },
    });
    const vueContainer = document.createElement("div");
    teethList.appendChild(vueContainer);
    itemInstance.$mount(vueContainer);
  });
}

function highlightItem(item) {
  if (vueApp.isHidden) return;

  if (!vueApp.getFocusedTooth()) {
    vueApp.allTeeth.forEach(function (model) {
      unhighlightItem(model);
    });
    if (item && item.isVisible && !item.isHidden) {
      setHighlightedToothColor(item);
      if (vueApp.isDicomOpen) {
        highlightOutlines(item);
      }
    }
  }
}

function unhighlightItem(item) {
  if (vueApp.isHidden) return;

  if (!vueApp.getFocusedTooth()) {
    if (item && item.isVisible && !item.isHidden) {
      let color = vueApp.getActualColor(item);
      viewer.set_color(item.id, color);
    }
    if (vueApp.isDicomOpen) {
      highlightOutlines(null);
    }
  }
}

function focusItem(item) {
  vueApp.allTeeth.forEach(function (model) {
    if (model != item && model.isVisible) {
      model.isFocused = false;
      model.isHidden = true;
    }
  });

  if (item) {
    item.isVisible = item.isFocused = true;
    item.isHidden = false;

    focusTooth(item);
  }
}

function unfocusItem() {
  vueApp.allTeeth.forEach(function (model) {
    model.isFocused = false;
    model.isHidden = false;
  });

  unfocusTooth(false);
}

function deleteItem(item) {
  console.log("deleteItem", item);

  if (vueApp.isViewMode) {
    swal({
      text: "Cannot delete in the view mode.",
    });
    return;
  }

  if (item && item.isTooth && !item.isDeleted) {
    swal({
      text: "Are you sure you want to delete this tooth?",
      buttons: {
        yes: { text: "Yes", value: true },
        no: { text: "No", value: false },
      },
    }).then((willDelete) => {
      if (willDelete) {
        if (item.isFocused) {
          unfocusItem();
        }

        item.isDeleted = true;
        var mesh = viewer.get_model_mesh(item.id);
        if (mesh) {
          viewer.remove_model(item.id);
        }
        vueApp.removeItem(item);
        vueApp.$emit("visibilityChanged", item);

        sendRemoveTeethRequest([item]);
      }
    });
  }
}

function editItemSettings(item) {
  if (item && !item.isDeleted && item.isTooth) {
    initToothNumberControls();

    // ToothNumberMode.setChangingTooth(item);
    showToothNumberDialog(item, true);
  }
}

export {
  fillTeethList,
  highlightItem,
  unhighlightItem,
  focusItem,
  unfocusItem,
  deleteItem,
  editItemSettings,
};
